<template>
  <model-form
    :model="registerPage"
    :submodel="true"
    modal-type="modal"
  >
    <q-card-section>
      <div class="row q-gutter-md">
        <q-select
          v-model="registerPage.type"
          class="col"
          label="Type"
          :options="registerPage.fieldOptions('type')"
          emit-value
          map-options
          :rules="[val => val !== null || 'Field is required']"
          bottom-slots
          autofocus
        />
        <q-select
          v-if="registerPage.type === REGISTER_PAGE_TYPES.BUTTON_GRID"
          v-model="registerPage.registerGrid"
          class="col"
          label="Register Grid"
          :options="registerGridOptions"
          emit-value
          :display-value="registerPage.registerGrid ? registerPage.registerGrid.name : ''"
          :rules="[val => val !== null || 'Field is required']"
          bottom-slots
        />
        <q-select
          v-if="registerPage.type === REGISTER_PAGE_TYPES.CATEGORY"
          v-model="registerPage.category"
          class="col"
          label="Category"
          :options="categoryOptions"
          emit-value
          :display-value="registerPage.category ? registerPage.category.name : ''"
          :rules="[val => val !== null || 'Field is required']"
          bottom-slots
        />
        <q-select
          v-if="registerPage.type === REGISTER_PAGE_TYPES.SPECIFIC_ACTIVITY"
          v-model="registerPage.activity"
          class="col"
          label="Activity"
          :options="activityOptions"
          emit-value
          map-options
          :display-value="registerPage.activity ? registerPage.activity.name : ''"
          :rules="[val => val !== null || 'Field is required']"
          bottom-slots
        />
        <div class="column q-mb-md">
          <q-select
            v-if="registerPage.type === REGISTER_PAGE_TYPES.SPECIFIC_CATEGORYS"
            v-model="registerPage.categories.data"
            class="row"
            label="Category"
            option-label="name"
            multiple
            emit-value
            map-options
            :options="categories.data"
            use-chips
            :rules="[val => val !== null || 'Field is required']"
            bottom-slots
          />
          <q-toggle
            v-if="registerPage.type === REGISTER_PAGE_TYPES.SPECIFIC_CATEGORYS"
            v-model="registerPage.config.exlcudeItemCategories"
            class="row"
            :label="(registerPage.config.exlcudeItemCategories ? 'Exclude' : 'Include') + ' Item Categories'"
          />
        </div>
        <q-select
          v-if="registerPage.type === REGISTER_PAGE_TYPES.KITCHEN_DISPLAY"
          v-model="registerPage.kitchenDisplay"
          class="col"
          label="Kitchen Display"
          :options="$_.filter(kitchenDisplays.data, 'isUnarchived')"
          option-label="name"
          emit-value
          map-options
          :rules="[val => val !== null || 'Field is required']"
          bottom-slots
        />
      </div>
      <div class="row q-gutter-md">
        <q-input
          v-model="registerPage.displayName"
          class="col"
          label="Display Name"
          :rules="[val => !!val || 'Field is required']"
          bottom-slots
        />
        <q-btn
          :icon="registerPage.iconName"
          size="lx"
          class="col q-mb-lg q-mt-lg"
          outline
          @click="$refs.iconPickerDialog.show()"
        />
      </div>
    </q-card-section>
    <icon-picker-dialog
      ref="iconPickerDialog"
      :model="registerPage"
      icon-property="iconName"
    />
  </model-form>
</template>

<script>

import { REGISTER_PAGE_TYPES } from 'src/models/register/RegisterPage'
import IconPickerDialog from 'src/modules/admin/components/IconPickerDialog.vue'
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'

export default {
  name: 'RegisterPageForm',
  components: {
    ModelForm,
    IconPickerDialog
  },
  models: {
    registerPage: {
      editing: true,
      registerGrid: 'default',
      kitchenDisplay: 'default',
      categories: true,
      activity: 'default'
    }
  },
  configuration: ['registerGrids', 'categories', 'kitchenDisplays', 'activities'],
  computed: {
    registerGridOptions () {
      return _.map(this.registerGrids.data, model => { return { value: model, label: model.name } })
    },
    categoryOptions () {
      return _.map(this.categories.data, model => { return { value: model, label: model.name } })
    },
    activityOptions () {
      return _.map(this.activities.data, model => { return { value: model, label: model.name } })
    }
  },
  watch: {
    'registerPage.type' () {
      if (this.registerPage.type === REGISTER_PAGE_TYPES.ACTIVITY_TICKET) {
        this.registerPage.displayName = 'Activities'
      } else {
        this.registerPage.displayName = _.startCase(this.registerPage.type)
      }
    },
    'registerPage.registerGrid' () {
      this.registerPage.displayName = _.startCase(this.registerPage.registerGrid?.name)
    },
    'registerPage.category' () {
      this.registerPage.displayName = _.startCase(this.registerPage.category?.name)
    },
    'registerPage.activity' () {
      this.registerPage.displayName = _.startCase(this.registerPage.activity?.name)
    }
  },
  created () {
    _.extend(this, { REGISTER_PAGE_TYPES })
  }
}

</script>
